<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Tipo de Conteúdo - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'contentTypes'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-content-type :btnLabel="btnLabel"></form-content-type>
</span>
</template>

<script>
import FormContentTypeComponent from "./partial/FormContentTypeComponent";

export default {
    name: "AddContentTypeComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formContentType: FormContentTypeComponent,
    }
};
</script>

<style scoped>

</style>
